import type { Loan } from 'app/types/loan';
import { LoanStatus } from 'app/types/loan';
import { isAfter, isBefore, isSameDay, startOfDay } from 'app/lib/date';

// A return recorded before the planned start cannot define a calendar interval.
// Keep the scheduled range instead of producing a negative-width loan bar.
export function getLoanRangeEnd(loan: Pick<Loan, 'start' | 'end' | 'returned'>) {
  const start = startOfDay(new Date(loan.start));
  const returned = loan.returned ? startOfDay(new Date(loan.returned)) : undefined;
  return returned && !isBefore(returned, start) ? returned : startOfDay(new Date(loan.end));
}

export function getLoanCalendarEnd(loan: Pick<Loan, 'start' | 'end' | 'returned' | 'status'>, today = new Date()) {
  const plannedOrActualEnd = getLoanRangeEnd(loan);

  if (loan.status === LoanStatus.Accepted && !loan.returned && isBefore(plannedOrActualEnd, startOfDay(today))) {
    return startOfDay(today);
  }

  return plannedOrActualEnd;
}

export function loanOccursOnDate(
  loan: Pick<Loan, 'start' | 'end' | 'returned' | 'status'>,
  date: Date,
  today = new Date(),
) {
  const day = startOfDay(date);
  const start = startOfDay(new Date(loan.start));
  const end = getLoanCalendarEnd(loan, today);

  return isSameDay(day, start) || isSameDay(day, end) || (isAfter(day, start) && isBefore(day, end));
}
